<template>
    <div>
        <button
            v-if="variant === 'preview'"
            type="button"
            class="be-preview"
            :disabled="loadingDownloadPdf"
            @click.prevent="exportPDF()"
        >
            <i
                v-if="loadingDownloadPdf"
                class="fal fa-spinner-third fa-spin be-preview-icon"
            ></i>
            <IconDownload v-else class="be-preview-icon be-preview-icon--svg" />
            <span>{{ $t('post.page.button.export') }}</span>
        </button>

        <button
            v-else
            type="button"
            :class="{
                'buttonExport inline-flex justify-content-between items-center px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 w-36': true,
                'h-9': variant == 'minimal'
            }"
            @click.prevent="exportPDF()"
        >
            <IconDownload class="h-5 w-5" v-show="!loadingDownloadPdf" />
            <i
                v-show="loadingDownloadPdf"
                class="fas fa-circle-notch fa-spin mr-2 h-4 w-4 text-white"
            ></i>
            {{ $t('post.page.button.export') }}
        </button>

        <div id="postExport">
            <div :id="'mapImgDiv' + post.id"></div>
        </div>
    </div>
</template>
<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions } from 'vuex'

export default {
    props: ['post', 'variant'],
    data() {
        return {
            loadingDownloadPdf: false,
            baseUrl: this.$store.state.baseURL,
            token: this.$store.state.auth.token
        }
    },
    methods: {
        ...mapActions('post', ['getPost', 'searchUsersList', 'exportPdfPost']),
        exportPDF() {
            this.loadingDownloadPdf = true
            var map = document.getElementById('myMap')

            if (map) {
                map.style.height = 'calc(100vh - 500px)'
                this.delay(3000).then(() => {
                    domtoimage.toPng(map).then(function (dataUrl) {
                        var img = new Image()
                        img.src = dataUrl
                        img.setAttribute('id', 'mapImg' + this.post.id)
                        var divImg = document.getElementById(
                            'mapImgDiv' + this.post.id
                        )
                        divImg.appendChild(img)
                        map.style.height = 'calc(100vh - 330px)'
                    })
                    this.exportPDFHandler()
                })
            } else {
                this.exportPDFHandler()
            }
        },
        delay(time) {
            return new Promise((resolve) => setTimeout(resolve, time))
        },
        exportPDFHandler() {
            this.delay(3000).then(() => {
                var divImg = document.getElementById('mapImg' + this.post.id)
                var mapView = null
                if (divImg) {
                    var pdfView = {
                        name: `map_img_post_${this.post.id}`,
                        ext: `png`,
                        encodedFile: divImg.src
                    }
                    mapView = { mapImg: pdfView }
                }
                this.exportPdfPost(mapView)
                    .then(() => {
                        const link = document.createElement('a')
                        link.href = `${this.baseUrl}/storage/posts/${this.post.reference}/export/pdf/download?token=${this.token}`
                        link.download
                        link.click()
                    })
                    .finally(() => {
                        this.loadingDownloadPdf = false
                    })
            })
        }
    }
}
</script>

<style scoped>
/* Preview variant — used inside the ticket quick-view drawer, matches
 * the sibling toolbar buttons (solid cyan primary). */
.be-preview {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 12px;
    border: 1px solid var(--v2-primary, #0891b2);
    background: var(--v2-primary, #0891b2);
    color: #fff;
    font-size: 0.8125rem;
    font-weight: 500;
    border-radius: var(--v2-radius-md, 8px);
    cursor: pointer;
    transition: all 120ms ease;
    white-space: nowrap;
}

.be-preview:hover:not(:disabled) {
    background: var(--v2-primary-hover, #0e7490);
    border-color: var(--v2-primary-hover, #0e7490);
}

.be-preview:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.be-preview-icon {
    color: #fff;
    font-size: 0.85rem;
    flex-shrink: 0;
}

.be-preview-icon--svg {
    width: 14px;
    height: 14px;
}
</style>
